/*
  Phase 2c — Zuletzt angesehen strip.

  On every PDP load:
    1. Push current product handle to localStorage[STORAGE_KEY] (FIFO, dedupe, cap 12)
    2. Read full list, exclude current handle, take up to 12
    3. If < MIN_RENDER candidates, leave strip hidden
    4. Otherwise: fetch each handle via the Section Rendering API
       (/products/<handle>?section_id=recently-card-trautis) in parallel,
       DOMParser, replaceChildren. Strip stays hidden if < MIN_RENDER cards
       survive (deleted products 404 → dropped). Liquid can't read query params,
       so a single ?handles=… endpoint is impossible.

  No innerHTML writes.
*/

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisRecentlyViewed = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var STORAGE_KEY = 'trautis.recently_viewed';
  var MAX_ENTRIES = 12;
  var MIN_RENDER = 2;
  var CARD_SECTION_ID = 'recently-card-trautis';

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw == null) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function pushHandle(handle) {
    if (!handle) return;
    var list = readList();
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_ENTRIES) list = list.slice(0, MAX_ENTRIES);
    writeList(list);
  }

  function buildRenderList(currentHandle) {
    var list = readList();
    return list.filter(function (h) { return h !== currentHandle; }).slice(0, MAX_ENTRIES);
  }

  function cardEndpointRoot() {
    var root = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  // Liquid can't read URL query params (the request object has no query_string),
  // so a single ?handles=… endpoint is impossible. Fetch each card via the
  // Section Rendering API in the product's OWN context → one request per handle.
  function buildCardFetchUrl(handle) {
    return cardEndpointRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION_ID;
  }

  // Fetch ONE card; resolves to the <article data-recently-card> node, or null
  // (404 = product gone, or a network error → drop quietly).
  function fetchCardNode(handle) {
    return fetch(buildCardFetchUrl(handle)).then(function (r) {
      if (!r.ok) return null;
      return r.text().then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-recently-card]');
      });
    }).catch(function (_) { return null; });
  }

  // Wire the prev/next carousel arrows — identical behaviour to „Ähnliche Produkte"
  // (product-similar-trautis.js). Arrows show only when the rail overflows; on
  // mobile they're hidden via CSS (≤749px) so swipe stays the only affordance.
  function setupArrows(stripEl, rail) {
    var prev = stripEl.querySelector('[data-strip-prev]');
    var next = stripEl.querySelector('[data-strip-next]');
    if (!prev || !next || !rail.addEventListener) return;

    function update() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      if (maxScroll <= 2) {
        // Content fits → no arrows at all.
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      // Hide (don't dim) the arrow you can't use at each scroll boundary.
      prev.hidden = rail.scrollLeft <= 1;
      next.hidden = rail.scrollLeft >= maxScroll - 1;
    }

    function step(direction) {
      var amount = Math.max(rail.clientWidth * 0.8, 200);
      rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', update, { passive: true });
    if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('resize', update);
    update();
  }

  function renderInto(stripEl, handles) {
    // Promise.all preserves handle order (most-recent first) regardless of which
    // request settles first. Strip stays hidden if fewer than MIN_RENDER cards
    // survive (e.g. some products deleted → 404).
    return Promise.all(handles.map(fetchCardNode)).then(function (nodes) {
      var cards = nodes.filter(Boolean);
      if (cards.length < MIN_RENDER) return;
      var rail = stripEl.querySelector('[data-strip-rail]');
      if (!rail) return;
      rail.replaceChildren.apply(rail, cards);
      stripEl.removeAttribute('hidden');
      // Strip is now visible → measure overflow + wire arrows.
      setupArrows(stripEl, rail);
    }).catch(function (_) {
      // Strip stays hidden on unexpected failure
    });
  }

  function init() {
    var strip = document.querySelector('[data-recently-strip]');
    if (!strip) return;
    var currentHandle = (strip.dataset && strip.dataset.currentHandle) || '';
    if (currentHandle) pushHandle(currentHandle);
    var renderList = buildRenderList(currentHandle);
    if (renderList.length < MIN_RENDER) return;
    renderInto(strip, renderList);
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    MAX_ENTRIES: MAX_ENTRIES,
    MIN_RENDER: MIN_RENDER,
    readList: readList,
    pushHandle: pushHandle,
    buildRenderList: buildRenderList,
    buildCardFetchUrl: buildCardFetchUrl,
    setupArrows: setupArrows,
    renderInto: renderInto,
    init: init,
  };
});
